import React from 'react';
import './ui.css';

export type Tone = 'neutral' | 'accent' | 'danger' | 'warning' | 'info';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  /** Leading status dot — status must never be colour alone, so keep the text too. */
  dot?: boolean;
}

export function Badge({ tone = 'neutral', dot = false, className, children, ...rest }: BadgeProps) {
  const cls = ['ui-badge', tone !== 'neutral' && `ui-badge--${tone}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {dot && <StatusDot tone={tone} />}
      {children}
    </span>
  );
}

export function StatusDot({ tone = 'neutral', className, ...rest }: { tone?: Tone } & React.HTMLAttributes<HTMLSpanElement>) {
  const cls = ['ui-dot', tone !== 'neutral' && `ui-dot--${tone}`, className].filter(Boolean).join(' ');
  return <span className={cls} aria-hidden="true" {...rest} />;
}
